import React, { useState } from 'react';
import { Grid, makeStyles, Button } from '@material-ui/core';
import Modal from 'react-modal';
import CloseIcon from '@material-ui/icons/Close';
import AlertIcon from '../../../assets/AlertIcon';
import Theme from '../../ui/Theme';

const useStyles = makeStyles(() => ({
  mainContent: {
    width: '443px',
    height: '153px',
    marginLeft: '16px',
    marginTop: '24px',
    background: Theme.palette.secondary.main,
  },
  deleteBtn: {
    width: '261px',
    height: '42px',
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  cancelBtn: {
    width: '166px',
    height: '42px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
  },
  contentTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    color: 'black',
    justifyContent: 'center',
    marginBottom: '8px',
  },
  contentSubTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    /* identical to box height */
    display: 'flex',
    justifyContent: 'center',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: '8px',
  },
  attentionContent: {
    width: '443px',
    height: '40px',
    marginLeft: '24px',
    marginTop: '24px',
  },
  attentionText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    marginLeft: '12px',
    color: Theme.palette.quad.main,
  },
  threeDots: {
    fontFamily: 'Montserrat',
    fonttyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    justifyContent: 'center',
    color: '#EB5757',
    marginBottom: '8px',
  },
  durationText: {
    fontFamily: 'Montserrat',
    fonttyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    display: 'flex',
    justifyContent: 'center',
    color: '#EB5757',
    marginBottom: '8px',
  },
  popupCloseBtn: {
    borderRadius: '50%',
    backgroundColor: Theme.palette.secondary.main,
    padding: '8px',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
    },
    cursor: 'pointer',
  },
  frame14: {
    width: '308px',
    height: '67px',
  },
  frame34: {
    width: '443px',
    height: '82px',
    marginLeft: '16px',
    marginTop: '20px',
  },
  title: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    color: 'black',
  },
  subTitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
}));

const ContestDeleteConfirmation = (props) => {
  const classes = useStyles();

  const [viewConfirm, setViewConfirm] = useState(props.open);

  const closePopup = () => {
    setViewConfirm(false);
    props.close();
  };
  const deleteFn = () => {
    closePopup();
    props.delFn();
  };

  return (
    <Modal
      isOpen={viewConfirm}
      onRequestClose={() => false}
      shouldCloseOnEsc={false}
      style={{
        overlay: { backgroundColor: 'hsla(50, 33%, 25%, 0.35)' },
        content: {
          display: 'flex',
          padding: '20px 16px 28px',
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: '475px',
          height: '258px',
          background: '#FFFFFF',
        },
      }}
    >
      <Grid container direction="column">
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            className={classes.frame34}
          >
            <Grid item>
              <Grid
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="flex-start"
                className={classes.frame14}
              >
                <Grid item>
                  <div className={classes.title}> Are you sure of deleting this contest</div>
                </Grid>
                <Grid item>
                  <div className={classes.subTitle}>You are making a permanent change</div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <CloseIcon className={classes.popupCloseBtn} onClick={closePopup} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignContent="center"
            style={{ marginTop: '30px' }}
          >
            <Grid item>
              <Grid
                container
                direction="column"
                justifyContent="center"
                alignContent="center"
                className={classes.attentionContent}
              >
                <Grid item>
                  <AlertIcon />
                </Grid>
                <Grid item>
                  <div className={classes.attentionText}>
                    By deleting this you will be losing all information and data related to this Contest. Please make
                    sure that you are not deleting something you might need later.
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item style={{ marginTop: '18px' }}>
              <Button variant="contained" disableElevation className={classes.cancelBtn} onClick={closePopup}>
                Don&apos;t Delete
              </Button>
              <Button variant="contained" className={classes.deleteBtn} onClick={deleteFn}>
                <div style={{ color: '#EB5757' }}>I’m sure! Delete this Contest</div>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ContestDeleteConfirmation;
